import Cookies from 'js-cookie';
import { ioaLogin, sendIoaLogout } from '../../../api';
import {
  getConfig,
  isSingaporeSupport,
  isSupportSystem,
} from '../../../config';
import {
  getDomain,
  getLocationSearchParam,
  getURLPathname,
  replaceURL,
} from '../../../lib';
import { jumpToLogin, redirectRemoveSecurity } from '../../lib';

const getSupportCookieKey = () => `${location.hostname}_INGAME_SUPPORT_TOKEN`;

export const removeSupportCookieToken = () => {
  const domain = getDomain();
  const opt = {
    path: '/',
    domain,
  };
  Cookies.remove(getSupportCookieKey(), opt);
};

export const getSupportCookieToken = () => {
  if (!isSupportSystem()) {
    return '';
  }
  return Cookies.get(getSupportCookieKey()) || '';
};

export const setSupportCookieToken = (token = '') => {
  const date = new Date();
  const hour = 11 * 60 * 60 * 1000; // 11小时过期
  const expireTime = Number(Date.parse(String(date)) + hour);

  const opt = {
    path: '/',
    expires: new Date(expireTime),
    domain: getDomain(),
  };

  return Cookies.set(getSupportCookieKey(), token, opt);
};

export const initIoaLogin = async () => {
  const token = getSupportCookieToken();
  if (token) {
    return true;
  }
  if (isSingaporeSupport()) {
    const ticket = getLocationSearchParam('ticket');
    if (!ticket) {
      jumpToLogin();
      return;
    }
    setSupportCookieToken(ticket);
    redirectRemoveSecurity();
    return true;
  }
  const ioaCode = getLocationSearchParam('code');
  if (!ioaCode) {
    jumpToLogin();
    return false;
  }
  const res = await ioaLogin(ioaCode);
  if (!res.token) {
    document.body.innerText = `登录失败，请刷新重试 ${JSON.stringify(
      res || ''
    )}`;
    return false;
  }
  setSupportCookieToken(res.token);
  redirectRemoveSecurity();
  return true;
};

export const jumpToSupportLogin = async () => {
  removeSupportCookieToken();
  if (isSingaporeSupport()) {
    const url = `${getConfig().userURL}?backurl=${encodeURIComponent(
      getURLPathname()
    )}&loginPlatform=support`;
    replaceURL(url);
    return;
  }

  const { ioaLoginConfig } = getConfig();
  if (!ioaLoginConfig) {
    return;
  }

  const url = `${ioaLoginConfig.loginURL}&url=${encodeURI(location.href)}`;
  replaceURL(url);
};

export const supportLogout = async () => {
  await sendIoaLogout();
  removeSupportCookieToken();
  if (isSingaporeSupport()) {
    jumpToLogin();
    return;
  }
  const { ioaLoginConfig } = getConfig();
  if (!ioaLoginConfig) {
    return;
  }
  const url = `${ioaLoginConfig.logoutURL}&url=${encodeURI(location.href)}`;
  replaceURL(url);
};
